import React from 'react'
import AutoForm from '@components/AutoForm'
import Button from '@components/Button'
import useMessage from '@hooks/useMessage'
import useRef from '@hooks/useRef'
import useUserId from '@hooks/useUserId'
import useWebsiteId from '@hooks/useWebsiteId'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import {useTranslation} from 'next-i18next'
import {Field} from 'simple-react-form'

import LoggedIn from '../LoggedIn'

export default function Forgot(props) {
  const {t} = useTranslation('auth')
  const userId = useUserId()
  const websiteId = useWebsiteId()
  const showMessage = useMessage()
  const form = useRef()
  const onSuccess = () => {
    showMessage(t('followInstructionsInEmail'))
  }
  if (userId) return <LoggedIn />
  return (
    <div>
      <AutoForm mutation="forgotPassword" ref={form} onSuccess={onSuccess} doc={{websiteId}}>
        <div className="label">Email</div>
        <Field fieldName="email" type={Text} placeholder="Email" fieldType="email" />
      </AutoForm>
      <br />
      {/* @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'. */}
      <Button onClick={() => form.current.submit()} primary>
        {t('resetPassword')}
      </Button>
      <br />
      <br />
    </div>
  )
}
